<template>
  <div class="faq-section">
    <h1 class="main-title">{{ mainHeading }}</h1>
    <p v-if="subHeading" class="vision-description">{{ subHeading }}</p>
    <div
      v-for="(category, index) in categories"
      :key="index"
      :class="faqCategoryClass"
    >
      <h2 class="category-title" @click="toggleCategory(index)">
        {{ category.title }}
        <span class="toggle-icon">
          <Vue-feather
            :type="isOpen[index] ? 'chevron-up' : 'chevron-down'"
            size="24"
          />
        </span>
      </h2>
      <div v-if="isOpen[index]" class="faq-answers">
        <div v-for="(item, idx) in category.items" :key="idx" class="faq-item">
          <h3 class="question">{{ item.question }}</h3>
          <p class="answer">{{ item.answer }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { isMobile } from "@/utils/helper";
import { computed } from "vue";

export default {
  name: "FAQSection",
  props: {
    mainHeading: {
      type: String,
      required: true,
    },
    subHeading: {
      type: String,
      default: null,
    },
    categories: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      isOpen: this.categories.map(() => false), // Initialize all categories as closed
    };
  },
  setup() {
    const faqCategoryClass = computed(() => {
      return isMobile() ? "faq-category-mobile" : "faq-category-desktop";
    });

    return {
      faqCategoryClass,
    };
  },
  methods: {
    toggleCategory(index) {
      this.isOpen[index] = !this.isOpen[index]; // Directly toggle the value
    },
  },
};
</script>

<style scoped>
.faq-section {
  color: black;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.main-title {
  font-size: 3rem;
  margin-bottom: 2rem;
  text-align: center;
  color: #000;
  font-weight: bold;
}

.vision-description {
  font-size: 1.2rem;
  padding: 1rem 2rem;
  color: #7e7e7e;
  width: 75%;
  max-width: 800px;
  margin: 0 auto 4rem;
  text-align: center;
}

@media (max-width: 768px) {
  .faq-section {
    width: 100%;
    align-items: stretch;
  }

  .main-title {
    font-size: 2rem;
    margin-bottom: 2.5rem;
    font-weight: bold;
  }

  .vision-description {
    width: 100%;
    padding: 0;
    margin-bottom: 2.5rem;
  }
}

.faq-category-desktop {
  padding: 1rem;
  border-bottom: 1px solid #f2f5f9;
  min-width: 800px;
  max-width: 800px;
}

.faq-category-mobile {
  margin-bottom: 1rem;
  border-bottom: 1px solid #f2f5f9;
  width: 100%;
}

.category-title {
  padding: 1rem;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.toggle-icon {
  margin-left: 1rem;
}

.faq-answers {
  padding: 1rem;
}

.faq-item {
  margin-bottom: 0.5rem;
}

.question {
  font-weight: bold;
  font-size: 1rem;
}

.answer {
  margin: 0.5rem 0 1rem 0;
  line-height: 1.5;
}
</style>
